import { ArrowLeft, LogOut } from 'lucide-react';
import { Toaster } from './components/ui/sonner';
import { useAuth } from './AuthContext';
import TeamStructure from './TeamStructure';
import './TeamPage.css';

export default function TeamPage({ onBack, backLabel = 'Back to Tools', embedded = false }) {
  const { user, logout } = useAuth();

  return (
    <div className={`tp-page ${embedded ? "tp-embedded" : ""}`} data-testid="team-page">
      <Toaster position="top-right" richColors />
      <header className="tp-header">
        <div className="tp-header-left">
          {onBack && (
            <button className="tp-back" onClick={onBack} data-testid="tp-back-btn">
              <ArrowLeft size={15} /> {backLabel}
            </button>
          )}
          <div className="tp-title-block">
            <span className="tp-kicker">NicheCom</span>
            <h1 className="tp-title">Team Structure</h1>
          </div>
        </div>
        {!embedded && (
        <div className="tp-header-right">
          <span className="tp-user">{user?.name}</span>
          <button className="tp-signout" onClick={logout} data-testid="tp-signout">
            <LogOut size={14} /> Sign Out
          </button>
        </div>
        )}
      </header>
      <main className="tp-main">
        <TeamStructure fullscreen />
      </main>
    </div>
  );
}
